export default "__VITE_ASSET__xFmN679K__";